import L from 'leaflet';
import proj4 from 'proj4';
import { type ReactElement } from 'react';
import { toWgs84 } from 'reproject';
import { iconIdFilter, maskArea, roadSituation } from '../LayerFactories';
import { LeafletMap } from '../Map';

import type { PageMapProps } from './types';

interface SubscriptionAreaPageMapProps extends PageMapProps {
    pageId: number;
    sweref99GeoArea: string;
    situationIconIds: number[];
}

export const SubscriptionAreaPageMap = (props: SubscriptionAreaPageMapProps): ReactElement => {
    const mapProps = props.mapSettings;
    const setupMap = (map: L.Map): void => {
        const region = mapProps.region.toLowerCase();

        const area = toWgs84(JSON.parse(props.sweref99GeoArea), '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs', proj4);

        maskArea([area.geometry], { fillColor: '#000000', fillOpacity: 0.2 }).addTo(map);
        const situationLayer = roadSituation(region, props.pageId);
        situationLayer.addTo(map);
        iconIdFilter([situationLayer], props.situationIconIds).addTo(map);

        map.fitBounds(L.geoJSON(area).getBounds());
    };

    return <LeafletMap {...mapProps} onMapInitiated={setupMap} />;
};
